import BackendOrderManager from 'admin/order';

export default () => null;
export const orderNum = 6;
export const title = '置頂方案/訂單';
